import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';
import { title } from 'process';



interface Props {
    idSelector: number;
    onChange: any;
    idProcess: number;
    titulo?: string;
}

export const SelectorClaseTramites = ({ idSelector, onChange, idProcess, titulo }: Props) => {

    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector != id) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        if (idProcess) {
            getLista();
        }
    }, [idProcess])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        service.getBusinessProcessCatalog(null, null, null, idProcess, null, null).subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                //console.log("DataAcces", lista);
            }
        );
    }

    return (
        <>
            <label>{titulo ?? "Tramites"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                setValue(valor)
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBusinessProcess} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}